export default class VoyageConstraintsData {
    constructor({
        id,
        maxTurningAngle,
        maxWindServiceSpeed,
        maxWindCruiseSpeed,
        maxWaveServiceHeight,
        maxWaveCruiseHeight,
    }) {
        this.id = id;
        this.maxTurningAngle = maxTurningAngle;
        this.maxWindServiceSpeed = maxWindServiceSpeed;
        this.maxWindCruiseSpeed = maxWindCruiseSpeed;
        this.maxWaveServiceHeight = maxWaveServiceHeight;
        this.maxWaveCruiseHeight = maxWaveCruiseHeight;
    }
}